import { ICellAdapter } from "./ICellAdapter";

import { ColumnDefinition } from "../model/ColumnDefinition";

export class StringAdapter implements ICellAdapter {
  constructor() {}

  adapt(column: ColumnDefinition, row: any, ...modelObjects: any[]): void {
    // Nesting within modelObjects should be applied in a more specific adapter

    row[column.data] = this.retrieveData(modelObjects[0], column.data);
    row[column.sortKey] = this.retrieveSort(modelObjects[0], column.data);
    row[column.filterKey] = this.retrieveFilter(modelObjects[0], column.data);

    if (column.hasSearchKey) {
      row[column.searchKey] = this.retrieveSearch(modelObjects[0], column.data);
    }
  }

  retrieveData(order: any, columnProperty: string): string {
    if (order && typeof order[columnProperty] === "string") {
      if (
        order[columnProperty] != undefined &&
        order[columnProperty] != null &&
        order[columnProperty] != ""
      ) {
        return order[columnProperty];
      }
    }
    return "-";
  }
  // this can be overwridden if the data contains html markup,
  //  by default its the same as the data
  retrieveSort(order: any, columnProperty: string): string {
    let sortKey: string = this.retrieveData(order, columnProperty);
    return sortKey != null ? sortKey.toLowerCase() : "";
  }

  retrieveSearch(order: any, columnProperty: string): any {
    return this.retrieveSort(order, columnProperty);
  }

  retrieveFilter(order: any, columnProperty: string): string {
    return this.retrieveData(order, columnProperty);
  }
}
